package com.essntl.uikit.components.chat.conversation.overviewcard

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.chat.conversation.ConversationType
import com.essntl.uikit.components.icons.EsSmallIcon
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun EsConversationTypeUi(
    conversationType: ConversationType?,
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(4.dp),
        modifier = modifier,
    ) {
        EsSmallIcon(
            res = conversationType?.icon ?: "",
            tint = conversationType?.iconColor ?: MaterialTheme.esColorScheme.iconPrimary,
        )

        Text(
            text = "Via ${conversationType?.value ?: ""}",
            style = MaterialTheme.esTypography.c1Medium11.copy(
                color = MaterialTheme.esColorScheme.textSecondary,
            ),
        )
    }
}